import { apiClient } from "@/services/apiClient";

/** One query the model ran, surfaced so an answer can be checked. */
export interface AnalyticsChatStep {
  sql: string;
  rowCount: number;
  truncated: boolean;
  rows: Array<Record<string, unknown>>;
  error?: string;
}

export interface AnalyticsChatTurn {
  answer: string;
  steps: AnalyticsChatStep[];
}

export interface AnalyticsChatMessage {
  role: "user" | "assistant";
  content: string;
}

export function getAnalyticsChatStatus(): Promise<{ configured: boolean }> {
  return apiClient
    .get<{ configured: boolean }>("/platform/analytics/status")
    .then((res) => res.data);
}

export function askAnalytics(
  question: string,
  history: AnalyticsChatMessage[],
): Promise<AnalyticsChatTurn> {
  return apiClient
    .post<AnalyticsChatTurn>("/platform/analytics/ask", { question, history })
    .then((res) => res.data);
}

export interface AnalyticsBrief {
  markdown: string;
  generatedAt: string | null;
  error: string | null;
}

/** Reads the stored brief. Never generates — see the controller for why. */
export function getAnalyticsBrief(): Promise<AnalyticsBrief> {
  return apiClient
    .get<AnalyticsBrief>("/platform/analytics/brief")
    .then((res) => res.data);
}

export function refreshAnalyticsBrief(): Promise<{
  markdown: string;
  error: string | null;
}> {
  return apiClient
    .post<{ markdown: string; error: string | null }>(
      "/platform/analytics/brief/refresh",
    )
    .then((res) => res.data);
}
